import { render, staticRenderFns } from "./StoreClosed.vue?vue&type=template&id=198b0b00"
import script from "./StoreClosed.vue?vue&type=script&lang=js"
export * from "./StoreClosed.vue?vue&type=script&lang=js"
import style0 from "./StoreClosed.vue?vue&type=style&index=0&id=198b0b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports